// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    action_has_been_successfully_undone: '{0} se ha deshecho correctamente',
    action_has_not_been_successfully_undone: 'Lo sentimos, pero no pudimos deshacer la acción.',
    action_will_be_undo_message: 'La acción será deshecha: {0}',
    ActivityChildrenActualHours_Text: 'Registros de tiempo para todas las subactividades:',
    ActivityChildrenEstimatedHours_Text: 'Horas estimadas para todas las subactividades:',
    ActivityOwnBudget_Text: 'Presupuesto para la actividad:',
    ActivityOwnEstimatedHours_Text: 'Horas estimadas para la actividad:',
    ActivitySubactivitiesBudget_Text: 'Presupuesto para todas las subactividades:',
    ActualCompletion_Text: 'Finalización real',
    ActualHours_Total_Text: 'Horas reales gastadas, total:',
    AddTimeEntry_Text: 'Agregar registro de tiempo',
    AddUser_Text: 'Invitar usuario',
    AddWeeklyTime_Text: 'Agregar tiempo semanal',
    Apply: 'Aplicar',
    Assignees_Text: 'Asignados',
    BudgetedCost_Text: 'Presupuesto total del proyecto:',
    BudgetPadding_Text: 'Contingencia:',
    BudgetTotal_Text: 'Presupuesto, total:',
    Cancel: 'Cancelar',
    Close: 'Cerrar',
    Combobox_Add: 'Agregar ',
    Combobox_KeepTyping: 'Sigue escribiendo...',
    Combobox_MultipleSelectDefault: 'Selecciona algunas opciones',
    Combobox_NoResults: 'Sin resultados',
    Combobox_NoResultsMatch: 'Ningún resultado coincide con ',
    confirmation_description_dependent_date: 'Estás a punto de cambiar la fecha de una actividad que tiene dependencias. Esta acción ajustará los desfases de dependencia para alinearse con la nueva fecha que proporcionaste.',
    confirmation_title_dependent_date: 'Esta fecha está vinculada a una actividad dependiente',
    Cost_Text: 'Facturación:',
    CreateAndSelect: 'Crear y seleccionar',
    CustomerLabel: 'Cliente',
    day_template: '1#{0} día#{0} días',
    Duration_Text: 'Duración',
    EditProjectMembers_Title: 'Miembros del proyecto',
    EditTaskAssignees_Title: 'Asignados',
    End_Text: 'Fin',
    EndDate_Text: 'Fecha de finalización',
    EstimatedHours_Text: 'Horas estimadas:',
    EstimatedHours_Total_Text: 'Horas estimadas, total:',
    field_for_all_activities: 'Este campo es solo para actividades <b style=\"white-space: nowrap;\">({0} tareas, {1} incidencias, {2} solicitudes)</b>',
    field_for_issues: 'Este campo es solo para <b style=\"white-space: nowrap;\">{0} incidencias</b>',
    field_for_projects: 'Este campo es solo para <b style=\"white-space: nowrap;\">{0} proyectos</b>',
    field_for_requests: 'Este campo es solo para <b style=\"white-space: nowrap;\">{0} solicitudes</b>',
    field_for_tasks: 'Este campo es solo para <b style=\"white-space: nowrap;\">{0} tareas</b>',
    Hours_Short_Text: 'h',
    HoursLeftLabel: 'Horas restantes:',
    InternalCost_Text: 'Costo real:',
    NonProjectMembers_Text: 'No miembros del proyecto',
    Not_Space_Members: 'No miembros del espacio',
    Overloaded_Text: 'Sobrecargado',
    OwnActualHours_Text: 'Registros de tiempo para la actividad:',
    PlannedExpenses_Text: 'Gastos planeados:',
    PortfolioLabel: 'Portafolio',
    Progress: 'Progreso',
    ProgressCalculatedBySubActivities: 'Basado en el progreso de las subactividades',
    ProjectChildrenActualHours_Text: 'Registros de tiempo para actividades:',
    ProjectChildrenEstimatedHours_Text: 'Horas estimadas para todas las actividades:',
    ProjectMembers_Text: 'Miembros del proyecto',
    ProjectOwnBudget_Text: 'Presupuesto de mano de obra para el proyecto:',
    ProjectOwnEstimatedHours_Text: 'Horas estimadas para el proyecto:',
    ProjectSubactivitiesBudget_Text: 'Presupuesto para todas las actividades:',
    Space_Members: 'Miembros del espacio',
    Start_Text: 'Inicio',
    StartDate_Text: 'Fecha de inicio',
    Teams_Text: 'Equipos',
    Timelogs_In_Past: 'No se recomienda editar el tiempo de una actividad que ocurrió hace más de {0}. ¿Estás seguro de que deseas continuar?',
    Timelogs_In_Past_Short: 'No se recomienda editar el tiempo de una actividad que ocurrió hace más de {0}',
    TimeLogs_Warning_Project_Closed: 'No se recomienda agregar tiempo a un proyecto cerrado. ¿Estás seguro de que deseas continuar agregando tiempo al proyecto cerrado?',
    TimeLogs_Warning_Project_Closed_Short: 'No se recomienda agregar tiempo a un proyecto cerrado',
    TimeLogs_Warning_Task_Closed: 'No se recomienda agregar tiempo a una actividad cerrada. ¿Estás seguro de que deseas continuar agregando tiempo a esta actividad cerrada?',
    TimeLogs_Warning_Task_Closed_Short: 'No se recomienda agregar tiempo a una actividad cerrada',
    Tooltip_Dependent_Template: '{0} está vinculado a una actividad dependiente y no puede ser cambiado',
    Tooltip_HasChildren_Template: '{0} se calcula en base a las subactividades y no puede ser cambiado',
    Tooltip_ItemCompleted: 'No se puede editar porque está vinculado a una actividad/proyecto cerrado.',
    Tooltip_NoRightForUserRole_Template: '{0} no puede ser cambiado. No tienes permiso para editar este campo',
    Tooltip_Open_Details: 'Por favor abre los detalles para editar este campo',
    undo_action_Project_UpdateActualCompletionDate: 'cambiar la fecha de finalización real del proyecto',
    undo_action_Project_UpdateDates: 'cambiar las fechas del proyecto',
    undo_action_Project_UpdateName: 'renombrar el proyecto',
    undo_action_Project_UpdateStatus: 'cambiar el estatus del proyecto',
    undo_action_Task_UpdateActualCompletionDate: 'cambiar la fecha de finalización real de la actividad',
    undo_action_Task_UpdateDates: 'cambiar las fechas de la actividad',
    undo_action_Task_UpdateDependencies: 'editar la dependencia',
    undo_action_Task_UpdateName: 'renombrar la actividad',
    undo_action_Task_UpdateStatus: 'cambiar el estatus de la actividad',
    undo_action_Task_UpdateWorkIsDone: 'establecer \'He terminado\' para la asignación de la tarea',
    Untitled: 'Sin título',
    Validation_ActComplDateRange: 'La fecha de finalización real no está dentro del rango esperado.',
    Validation_DateMandatory: 'La fecha es un campo obligatorio.',
    Validation_DurationMandatory: 'La duración es un campo obligatorio.',
    Validation_EndDateRange: 'La fecha de finalización no está dentro del rango esperado.',
    Validation_FieldMandatory: 'Este es un campo obligatorio.',
    Validation_FromDateRange: 'La fecha de inicio no está dentro del rango esperado.',
    Validation_Interger: 'El valor debe ser un número entero.',
    Validation_InvalidDate: 'La fecha debe estar en el formato \'{0}\'.',
    Validation_NumberRange: 'El valor debe estar entre {0} y {1}.',
    Validation_Range: 'El valor no está dentro del rango esperado.',
    Validation_StartDateRange: 'La fecha de inicio no está dentro del rango esperado.',
    Validation_ToDateRange: 'La fecha de finalización no está dentro del rango esperado.',
    Validation_WeekendOrVacation: 'El valor no debe caer en un fin de semana o día festivo.',
    Warning_UnassigneFromAllTasksInProject: 'Los miembros eliminados serán desasignados de todas las actividades en este proyecto.',
    Warning_UnassignFromAllTasksInProject_Single: 'El miembro eliminado será desasignado de todas las actividades en este proyecto.',
};
